import filesize from 'filesize';

function formatFileType(type: string): string {
  if (type === '*/*') return 'All file types';

  const wildcardMatch = /^([a-z]+)\/\*$/.exec(type);
  if (wildcardMatch) return `All ${wildcardMatch[1]} types`;

  if (type.includes('/')) {
    const subtype = type.split('/').pop()!;
    return subtype.toUpperCase();
  }

  return type.replace('.', '').toUpperCase();
}

/**
 * Generate a note string based on allowed file types and optional max file size
 * for use in Uppy's drag-drop UI
 */
export default function generateNoteString(allowedFileTypes: string[] | null, maxFileSize?: number): string {
  let fileTypesText = 'All file types';

  if (allowedFileTypes && allowedFileTypes.length > 0) {
    if (!allowedFileTypes.includes('*/*')) {
      const types = allowedFileTypes.map(formatFileType);
      if (types.length === 1) {
        [fileTypesText] = types;
      } else if (types.length === 2) {
        fileTypesText = types.join(' or ');
      } else {
        fileTypesText = `${types.slice(0, -1).join(', ')} or ${types.at(-1)}`;
      }
    }
  }

  if (maxFileSize != null) {
    const maxSizeText = filesize(maxFileSize);
    return `${fileTypesText} (max. ${maxSizeText})`;
  }

  return fileTypesText;
}
